import { useTranslation } from 'react-i18next';

export const CHATBOT_NAME = "Asystent AI";

export const useAppConstants = () => {
    const { t } = useTranslation();

    return {
        DEFAULT_CONVERSATION_TITLE_PREFIX: t('constants.conversationPrefix'),
        DATA_SOURCE_TITLE_PREFIX: t('constants.dataSourcePrefix'),
        CONVERSATION_GROUP_SECTIONS: {
            PINNED: t('constants.pinned'),
            TODAY: t('constants.today'),
            YESTERDAY: t('constants.yesterday'),
            LAST_7_DAYS: t('constants.lastSevenDays'),
            OLDER: t('constants.older'),
        }
    };
};

export const USER_ROLES = {
    SYSTEM_ADMIN: "SYSTEM_ADMIN",
    USER: "USER",
};
